
export const sendData = (name, data={}) => {
    window.dataLayer.push({
        'event': 'ga4-event',
        'eventName': name,
        'customLabel': data.score ? data.score : undefined
    });

}